import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { imageworkupService } from 'app/EMR/Image_workup/Services/Imageworkup.services';
import { AuthService } from 'app/auth/auth.service';
import { BillingserviceService } from 'app/billing/billingService.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';

@Component({
  selector: 'app-patient-files',
  templateUrl: './patient-files.component.html',
  styleUrls: ['./patient-files.component.scss']
})
export class PatientFilesComponent implements OnInit {
  displayedColumns: string[] = ['filename', 'select'];
  dataSource: any = [];
  folderName: string;
  constructor(public dialogRef: MatDialogRef<PatientFilesComponent>, public billingService: BillingserviceService,
    public authService: AuthService, public opdvisitService: OpdVisitService,public imageWorkupService :imageworkupService) { }

  ngOnInit(): void {
    let branchid = this.authService.Loggeduser.branchid;
    let patid = this.opdvisitService.patientdetails.pkRegId;
    this.folderName = 'PatientDocuments';
    this.patDocList(patid, branchid, this.folderName);
  }

  closedialog() {
    this.dialogRef.close();
  }

  patDocList(pid, bid, fname) {
    this.imageWorkupService.getAzureImagedata(pid, bid, fname).subscribe((data:any) => {
        if(data.length >0){
          data.forEach(element => {
            this.dataSource.push({ filename: element.documentName, select: false,fileurl:element.documentURL });
          });
        }
        });
        
        
    // this.billingService.getPatientDoc(pid, bid, fname).subscribe(data => {
    //   let docdata = data;
    //   docdata.filter(doc => doc != null).forEach(element => {
    //     this.dataSource.push({ filename: element, select: false, });
    //   });
    // });
  }

  onSelectClick(e) {
    this.billingService.patientdata = [];
    let selectedData = this.dataSource.filter(x => x.select == true);
    selectedData.forEach(item => {
      this.billingService.patientdata.push({filename:item.filename,fileurl:item.documentURL});
    });
    this.closedialog();
  }
}
